import Container from "react-bootstrap/Container";
import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";

function NavBar() {
  return (
    <Navbar bg="dark" variant="dark" expand="md" sticky="top" collapseOnSelect>
      <Container>
        <Navbar.Brand href="#">
          <img className="d-inline-block align-top" src="https://img.icons8.com/fluency/96/portfolio.png" width="32" height="32" alt="Portfolio icon" />{' '}
          Portfolio - Achuthan R
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className="ms-auto gap-md-3">
            <Nav.Item>
              <Nav.Link className="text-uppercase" href="#experience">Experience</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link className="text-uppercase" href="#skills">Skills</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link className="text-uppercase" href="#projects">Projects</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link className="text-uppercase" href="#contact">Contact</Nav.Link>
            </Nav.Item>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default NavBar;